import { render, staticRenderFns } from "./SmsSendHistory.vue?vue&type=template&id=325c7fe1&scoped=true"
import script from "./SmsSendHistory.vue?vue&type=script&lang=js"
export * from "./SmsSendHistory.vue?vue&type=script&lang=js"
import style0 from "./SmsSendHistory.vue?vue&type=style&index=0&id=325c7fe1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c7fe1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('325c7fe1')) {
      api.createRecord('325c7fe1', component.options)
    } else {
      api.reload('325c7fe1', component.options)
    }
    module.hot.accept("./SmsSendHistory.vue?vue&type=template&id=325c7fe1&scoped=true", function () {
      api.rerender('325c7fe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/SmsSendHistory.vue"
export default component.exports